import { WIDGET_TYPE_V2, WidgetRequestPayload } from '../../../types/widget';
import SuperFetchV2 from '../../superFetchV2';
import { WidgetsFindOneResponseBodyDto } from '../../../types/api/widgets';

const WidgetApiV2 = {
  getWidgetDetail: (id: number): Promise<WidgetsFindOneResponseBodyDto> => SuperFetchV2.get(`/widgets/${id}`),
  createWidget: (payload: { type: WIDGET_TYPE_V2; widget: WidgetRequestPayload }) =>
    SuperFetchV2.post('/widgets', payload),
  editWidget: (id: number, payload: { type: WIDGET_TYPE_V2; widget: WidgetRequestPayload }) =>
    SuperFetchV2.put(`/widgets/${id}`, payload),
  deleteWidget: (id: number): Promise<void> => SuperFetchV2.delete(`/widgets/${id}`),
};

export default WidgetApiV2;
